<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1jNedM/tc-custom/9781035829385.jpg?1705539731925" alt="This image is the cover for the book Clone Ladies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Clone Ladies
      </h1>
      <p class="bookDescription body article font2">
        <p>In Clone Ladies, dive into a near-future where medical advancements have made cloning not just possible, but commonplace. As technology evolves, it’s not just organs that are replicated – entire humans can now be duplicated, possessing the same abilities, thoughts, memories, and skills as their originals. While this brave new world promises enhanced happiness and longevity, it also introduces unprecedented challenges. What does it mean to be truly unique in a world of mirrors? This gripping exploration into the promises and pitfalls of cloning raises profound questions about identity, ethics, and the very essence of human existence.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ming Shu
      </h2>
      
      <p class="authorDescription body article">Ming Shu was born in a medical doctors’ family and is well educated. He works and lives in Carlisle, Cumbria. As an alternative medicine practitioner, he loves science and literature. Combining life experience and energetic thinking, he would like to be contributing more literary works to the public.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54d37ef3